// extracted by mini-css-extract-plugin
export var darkMode = "_y-0";